// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2gMz5","text":"SelectPayment_text__36kUi","title":"SelectPayment_title__1I4Aj","btn":"SelectPayment_btn__2sCYO"};